const userGroupEn = {
	userGroupTable: 'User Group',
	userGroupEditForm: 'User Group',
	name: 'Name',
};

export default userGroupEn;